import React from "react";

import "react-image-gallery/styles/css/image-gallery.css";
import AuthContext from "../../../../AuthContext";
import mtzApis from "../../../../services";
import LiteImageGallery from "../../../shared2/LiteImageGallery";
import "./style.css";
const { companyService } = mtzApis;

export default function CompanyImageSummary({ companyId, profileName }) {
  let [company, setCompany] = React.useState(null);
  const me = React.useContext(AuthContext);

  React.useEffect(() => {
    let mounted = true;

    (async () => {
      let company;
      if (companyId) {
        const companies = await companyService.getCompanies(
          new URLSearchParams(`companyIds=${companyId}`)
        );
        company = companies.length > 0 ? companies[0] : null;
      }
      if (profileName) {
        const companies = await companyService.getCompanies(
          new URLSearchParams(`profileName=${profileName}`)
        );
        company = companies.length > 0 ? companies[0] : null;
      }

      if (company === null) return;

      if (!company.images || company.images.length === 0)
        company.images = [];

      company.images = company.images.filter(i => !!i).map((img) => {
        if (img.filePath.startsWith('http')) return img;
        img.filePath = companyService.getBackendUrl() + img.filePath;
        return img;
      })

      if (mounted) setCompany(company);
    })();

    return () => { mounted = false };
  }, [companyId, profileName]);

  return (
    <div className="mtz-card">
      <h5 className="mtz-h5">Images:</h5>

      {company && company.images && company.images.length > 0 && (
        <>
          {
            (company.images && company.images.length > 0) &&
            <LiteImageGallery imgs={company.images} />
          }
        </>
      )}

      {
        !company || !company.images || !company.images.length && <div className="text-center text-muted">No images</div>
      }
    </div>
  );
}
